import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "./SubmitSalesInfo.module.sass";
import { ActionButton } from "colbi_web_ui/lib/components/inputs";
import I18n from "../../I18n";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import jsesc from "jsesc";

const SubmitSalesInfo = (props) => {
    const { alternativeProps, value, modules } = props;
    const { params } = useGlobalValue();

    const { projectId, fiscalYear, importId, locale } = params;

    const projectFiscalYears = alternativeProps && alternativeProps.projectData;
    const fileToRedirect = projectFiscalYears && projectFiscalYears[fiscalYear];
    const file = (fileToRedirect || []).find(({ id }) => id === parseInt(importId));
    const localeToUse = locale || "en";

    const customUrl =
        file && file.fileType
            ? `/${file.fileType}?filter=${stringifyFilter([
                  { column: "ID", filters: [{ value: `${importId}` }] },
              ])}`
            : "";

    const checkSubmissionModule = (modules || []).includes("submission_file");

    return (
        <div>
            {checkSubmissionModule && importId !== "full" ? (
                <div
                    className={`${styles["message"]} ${
                        value === 1
                            ? styles["message-success"]
                            : value === 2
                            ? styles["submitting-data"]
                            : ""
                    }`}
                >
                    <p>{I18n.translate`${
                        value === 1
                            ? "Data submitted"
                            : value === 2
                            ? "Submitting Data"
                            : "Data not submitted"
                    }`}</p>
                    {file && file["id"] !== "full" && (value === null || value === 0) ? (
                        <div className={`${styles["export-button"] || ""}`}>
                            <ActionButton
                                primary
                                onClick={() => {
                                    return (window.location.href = jsesc(
                                        `/${localeToUse}/${projectId}/repository/folders/${fiscalYear}${customUrl}`,
                                    ));
                                }}
                            >
                                {I18n.translate`Submit File`}
                            </ActionButton>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default SubmitSalesInfo;
